(() => {
  if (!customElements.get("predictive-search")) {
    class PredictiveSearch extends HTMLElement {
      constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector(".predictive-search");
        this.predictiveSearchResults.style.display = "none";
        this.searchDelete = this.querySelector(".search__delete");
        this.overlay = this.querySelector(".js-ps-overlay");

        this.input.addEventListener(
          "input",
          this.debounce(() => {
            this.onChange();
          }, 300).bind(this),
        );

        this.input.addEventListener("focus", () => {
          this.onChange();
        });

        this.overlay.addEventListener("click", () => {
          this.close();
        });
      }

      onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
          this.close();
          return;
        }

        this.classList.add("searching");

        this.getSearchResults(searchTerm);
      }

      getSearchResults(searchTerm) {
        fetch(
          `${window.Shopify.routes.root}search/suggest?q=${searchTerm}&resources[options][fields]=title,variants.sku,product_type,variants.title&section_id=predictive-search`,
        )
          .then((response) => {
            if (!response.ok) {
              const error = new Error(response.status);
              this.close();
              throw error;
            }

            return response.text();
          })
          .then((text) => {
            const resultsMarkup = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector("#shopify-section-predictive-search").innerHTML;
            this.predictiveSearchResults.innerHTML = resultsMarkup;
            this.open();
          })
          .catch((error) => {
            this.close();
            throw error;
          });
      }

      open() {
        this.predictiveSearchResults.style.display = "flex";
        this.overlay.classList.add("ps-overlay--show");
      }

      close() {
        this.predictiveSearchResults.style.display = "none";
        this.overlay.classList.remove("ps-overlay--show");
        this.classList.remove("searching");
      }

      checkClickOutside(e) {
        const dialogDimensions = this.getBoundingClientRect();
        if (
          e.clientX < dialogDimensions.left ||
          e.clientX > dialogDimensions.right ||
          e.clientY < dialogDimensions.top ||
          e.clientY > dialogDimensions.bottom
        ) {
          this.close();
        }
      }

      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }
    }

    customElements.define("predictive-search", PredictiveSearch);
  }
})();
